import React from "react";
import {useTranslation} from "react-i18next";
import {KatDatePicker, KatInput, KatLabel} from "@amzn/katal-react";
import {
    DATE_SUFFIX,
    TIME_SUFFIX,
    COMPOSITE_FIELD_VALUE_SEP
} from "src/common/constants/formConstants";

export type IDateTimePickerProps = {
    id: string;
    className?: string;
    label: string;
    value?: string;
};

export const DateTimePicker =
    React.forwardRef(function DateTimePicker(props: IDateTimePickerProps, ref: any) {
        const {id, className, label, value} = props;
        const {t} = useTranslation();
        const valueParts = value?.split(COMPOSITE_FIELD_VALUE_SEP);
        const dateValue = valueParts != undefined ? valueParts[0] : undefined;
        const timeValue = valueParts != undefined ? valueParts[1] : undefined;

        return (
            <div className={className}>
                <KatLabel text={label} />
                <div
                    id={id}
                    className={"date-time-picker-inner"}
                    ref={ref}
                >
                    <KatDatePicker
                        id={id + DATE_SUFFIX}
                        locale="en-US"
                        value={dateValue}
                    />
                    <div className="spacer-small" />
                    <KatInput
                        id={id + TIME_SUFFIX}
                        placeholder={"HH:MM"}
                        pattern="((2[0-3])|([01][0-9])):[0-5][0-9]"
                        value={timeValue}
                    />
                    <span className="spacer-xxsmall"/>
                    <div className="date-time-picker-timezone">
                        {t("UTC")}
                    </div>
                </div>
            </div>
        );
    }
)


